// extracted by mini-css-extract-plugin
module.exports = {"canvas":"Canvas_canvas"};